export default function initUploads() {

	const uploadDetails = document.getElementsByClassName("image__upload");

	for (let i = 0; i < uploadDetails.length; i++) {
		uploadDetails[i].addEventListener("change", function (e) {
			let btnUpload = this.querySelector("input");
			let errorMessage = this.querySelector(".error_msg");
			let btnRemove = this.querySelector(".file__remove");
			let btnEdit = this.querySelector(".file__edit");
			let rightExt = /\.(?=gif|jpg|png|jpeg)/gi.test(btnUpload.value);
			if (rightExt) {
				errorMessage.innerHTML = "";
				this.classList.add("file_uploading");
				setTimeout(
					function () {
						this.classList.add("file_uploaded");
					}.bind(this),
					3000
				);
				let uploadedFile = URL.createObjectURL(e.target.files[0]);
				setTimeout(
					function () {
						this.querySelector(".upload__preview").setAttribute(
							"style",
							"background-image: url(" + uploadedFile + ");"
						);
					}.bind(this),
					3500
				);
			} else {
				errorMessage.innerHTML = "Alleen JPG, PNG, GIF of JPEG toegestaan";
			}

			btnRemove.addEventListener("click", function () {
				let	fileUpload = this.closest(".image__upload");
				fileUpload.classList.remove("file_uploading");
				fileUpload.classList.remove("file_uploaded");
				fileUpload.querySelector(".upload__preview").removeAttribute("style");
			});


			btnEdit.addEventListener("click", function (e) {
					console.log(this);
					const fileUpload = this.closest(".image__upload");
					fileUpload.classList.remove("file_uploading");
					fileUpload.classList.remove("file_uploaded");
					fileUpload.querySelector(".upload__preview").removeAttribute("style");
			});
		});
	}
}